<template>
	<div>
		<a-modal :title="$t('studentsCom.tradingOrder')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
			:pagination="false">
			<div class="ftr-1 cl-black">
				<div class="cl-info">
					{{$t('studentsCom.uploadDataDecision')}}
				</div>
				<div class="mt-4">
					{{$t('studentsCom.explanationAndProof')}}
				</div>
				<div class="cl-info">
					{{$t('studentsCom.uploadEvidenceTip')}}
				</div>
				<textarea class="mt-3 border-gray wid-100 p-2 br4" style="height: 150px;" placeholder="请输入"
				v-model="teacher_content" ></textarea>
				
				<div class="mt-3 border-gray wid-100 text-center py-2">
					{{$t('studentsCom.uploadImage')}}
				</div>
				<div class="mt-2">
					<upload-list v-model="teacher_files"></upload-list>
				</div>
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()"> {{$t('common.cancel')}} </button>
					<button type="button" class="btn btn-theme ml16 px-4" @click="platformRuling()">{{$t('common.submit')}}</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import uploadList from '../../../components/upload/list.vue'
	export default {
		components:{
			uploadList
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			order_id:{
				type: Number,
				default: 0,
			}
		},
		data() {
			return {
				teacher_files:[],
				teacher_content:''
			}
		},
		created() {
	
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			platformRuling(){
				this.$confirm({
					title: this.$t('unresolved.platformProcessing'),
					content: this.$t('unresolved.unresolved'),
					okText: this.$t('common.confirm'),
					okType: "danger",
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/reservation/platformRuling',{
							order_id:this.order_id,
							teacher_content:this.teacher_content,
							teacher_files:this.teacher_files
						}).then(res=>{
							this.$message.success(this.$t('common.operationSuccessful'),1,()=>{
								this.$emit('confirm')
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
			}
		}
	}
</script>

<style>
</style>